import React from "react";

import constants from "App/modules/consts";
import { LinkifiedText } from "App/common/LinkifiedText/LinkifiedText";
import { TextInput } from "../../TextInput";

export const TextBlock = (props: {
  isEditing: boolean;
  data: TextBlock;
  onChange: (block: TextBlock) => void;
  onSave: (block: TextBlock) => void;
}) => {
  const { isEditing, onChange, onSave, data } = props;

  const onInputChange = (value: string) => {
    onChange({ ...data, text: value });
  };

  const onSubmit = () => {
    if (!data.text) return;
    onSave(data);
  };

  return (
    <div className="text-block" data-is-editing={isEditing}>
      {isEditing ? (
        <TextInput
          isDisabled={!isEditing}
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          autoFocus={!(window as any).isTouchDevice}
          onSubmit={onSubmit}
          placeholder="Type here..."
          value={data.text}
          maxLength={constants.longMaxLength}
          onChange={onInputChange}
        />
      ) : (
        // Read-only display: render the body as text with any URLs turned
        // into clickable links. Shared by comment cards, reply threads,
        // and chat messages — they all render text comments via this block.
        <LinkifiedText text={data.text} />
      )}
    </div>
  );
};
